export interface MarketingLinkItem {
  /** A short tag beside the label in the nav, e.g. "New". */
  badge?: string;
  /** Pages grouped under this one: the desktop nav lists them in a menu. */
  children?: MarketingLinkItem[];
  /** One line under the label in the nav menu. */
  description?: string;
  href: string;
  label: string;
}

export interface MarketingFooterSection {
  links: MarketingLinkItem[];
  title: string;
}

export const MARKETING_APP_ENTRY_HREF = '/app/courses';

export const marketingPrimaryNavItems: MarketingLinkItem[] = [
  { href: '/faculty', label: 'For Faculty' },
  { href: '/institutions', label: 'For Institutions' },
  {
    children: [
      { description: 'The course-aware AI in every Kudu course', href: '/ai', label: 'KAI' },
      {
        badge: 'New',
        description: 'Socratic coaching for writing and reasoning',
        href: '/kai-coach',
        label: 'Kai Coach',
      },
    ],
    href: '/ai',
    label: 'AI',
  },
  { href: '/research', label: 'Research' },
  { href: '/humanities', label: 'Humanities' },
  { href: '/about', label: 'About' },
  { href: '/help', label: 'Help' },
];

// Only pages with content (#175): subjects and pricing are sections of the
// faculty and institutions pages.
export const marketingFooterSections: MarketingFooterSection[] = [
  {
    title: 'Product',
    links: [
      { href: '/faculty', label: 'For Faculty' },
      { href: '/institutions', label: 'For Institutions' },
      { href: '/kai-coach', label: 'Kai Coach' },
      { href: '/faculty#subjects', label: 'Subjects' },
      { href: '/institutions#pricing', label: 'Pricing' },
    ],
  },
  {
    title: 'Trust',
    links: [
      { href: '/ai', label: 'AI Position' },
      { href: '/accessibility', label: 'Accessibility' },
      { href: '/privacy', label: 'Privacy' },
      { href: '/research', label: 'Research' },
    ],
  },
  {
    title: 'Company',
    links: [
      { href: '/about', label: 'About' },
      { href: '/press', label: 'Press' },
    ],
  },
  {
    title: 'Contact',
    links: [
      { href: '/help', label: 'Help' },
      { href: '/contact', label: 'Contact' },
    ],
  },
];

export const marketingFooterLegalLinks: MarketingLinkItem[] = [
  { href: '/privacy', label: 'Privacy' },
  { href: '/accessibility', label: 'Accessibility' },
  { href: '/contact', label: 'Contact' },
];
